import Which from "assets/images/which/which.png";
import QDOS from "assets/images/qdos/QDOS.png";
import Landlord from "assets/images/landlord/landlords.png";
import LandlordWorks from "assets/images/landlord-works/landlord-works.png";
import Coco from "assets/images/coconut/coconut.png";

export const errorCodes = [
  {
    title: "old_password",
    indexed: true,
  },
  {
    title: "error",
    indexed: false,
  },
  {
    title: "common",
    indexed: true,
  },
  {
    title: "email",
    indexed: true,
  },
  {
    title: "non_field_errors",
    indexed: true,
  },
];

export const affiliateValues = {
  idev_username: "",
  utm_source: "",
  utm_medium: "",
  utm_campaign: "",
  affiliate_id: "",
};

export const setNewCompany = {
  aff_id: "",
  name: "",
  aff_name: "",
  background: "",
  logo: {
    image: Landlord,
    width: "145px",
  },
};
export const Companies = {
  landlord_works: {
    aff_id: 427,
    name: "landlord_works",
    aff_name: "Nationwide - Landlord Works",
    background: "",
    logo: {
      image: LandlordWorks,
      width: "330px",
    },
  },
  landlords: {
    aff_id: 109,
    name: "landlords",
    aff_name: "GSTLandlords",
    background: "",
    logo: {
      image: Landlord,
      width: "280px",
    },
  },
  which_mem: {
    aff_id: 108,
    name: "which",
    aff_name: "WhichMem(internal)",
    signup: true,
    background: "#66D7D1",
    logo: {
      image: Which,
      width: "400px",
    },
  },
  which_non_mem: {
    aff_id: 107,
    aff_name: "WhichNon",
    name: "which",
    signup: true,
    background: "#66D7D1",
    logo: {
      image: Which,
      width: "400px",
    },
  },
  cybg: {
    aff_id: 228,
    name: "cybg",
    aff_name: "CYBG",
    background: "",
    logo: "",
  },
  landlord: {
    aff_id: "",
    name: "landlord",
    aff_name: "landlord",
    background: "",
    logo: "",
  },
  qdos: {
    aff_id: 422,
    name: "qdos",
    aff_name: "qdos_members_422",
    background: "",
    logo: {
      image: QDOS,
      width: "260px",
    },
  },
  qdos_non_member: {
    aff_id: 433,
    name: "qdos",
    aff_name: "qdos_non_member_433",
    background: "",
    logo: {
      image: QDOS,
      width: "260px",
    },
  },
  yacht: {
    aff_id: "",
    name: "yatch",
    aff_name: "yatch",
    background: "",
    logo: "",
  },
  justaccount: {
    aff_id: 136,
    name: "justaccount",
    aff_name: "Justacc",
    background: "",
    logo: "",
  },
  it_contracting: {
    aff_id: 233,
    name: "it_contracting",
    aff_name: "IT Contracting ",
    background: "",
    logo: "",
  },
  farepilot: {
    aff_id: 131,
    name: "farepilot",
    aff_name: "googleppctest",
    background: "",
    logo: "",
  },
  coconut: {
    aff_id: "",
    name: "coco_direct",
    aff_name: "coconut",
    background: "#3AA09B",
    logo: {
      image: Coco,
      width: "319px",
    },
  },
};

export const cocoAffiliate = {
  name: Companies["coconut"].name,
  logo: Companies["coconut"].logo,
};
